import { HStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { useRecoilQuery } from '../../../../../hooks/useRecoilQuery';
import { equityMarketStatusQuery } from '../../../../../store/product/selectors';
import { ProductButtonProps } from '../../../../BatchTicket/components/DynamicButton';
import { BookOffersButton } from '../../../../EquityOffersBookModal/components/BookOffersButton';
import { ApplicationButton } from '../../components/ApplicationButton';

export const EquitySellButton: React.FC<ProductButtonProps<'equitySell'>> = (props) => {
  const { data } = useRecoilQuery(equityMarketStatusQuery);

  const forceButtonDisable = !data || !data?.isOpen;

  return (
    <HStack space={Spacing['inline.nano']}>
      <BookOffersButton equity={props.offer} />
      <ApplicationButton
        {...props}
        isDisabled={props.isDisabled || forceButtonDisable}
        idSelector="productIdNormalized"
        buttonText="Vender"
        mobileButtonIconColor="product.rendavariavelsale"
        buttonVariant="secondary"
        backgroundColor="product.rendavariavelsale"
      />
    </HStack>
  );
};
